/**
 * oRPC 共通の認証付き fetch。401/403 は共通ハンドラに委譲する。
 */
import { getBaseUrl } from '@/lib/env';
import { i18next } from '@/lib/i18n/adapters/i18next';
import { handleAuthErrorResponse } from '../auth-error-response';
import { HTTP_STATUS } from '../http-status';
export const authFetch: typeof fetch = async (input, init) => {
  // Request が渡されても元ヘッダーを保持しつつ Accept-Language を補う（呼び出し側指定を優先）。
  const headers = new Headers(init?.headers ?? (input instanceof Request ? input.headers : undefined));
  const language = i18next.language;
  if (language && !headers.has('Accept-Language')) {
    headers.set('Accept-Language', language);
  }
  const response = await fetch(input, {
    ...init,
    headers,
    credentials: 'include',
    // 304(空ボディ)のエラー化を防ぐ（理由は lib/api/client.ts）。
    cache: 'no-store'
  });
  if (response.status === HTTP_STATUS.UNAUTHORIZED || response.status === HTTP_STATUS.FORBIDDEN) {
    await handleAuthErrorResponse(response);
  }
  return response;
};
export { getBaseUrl };